import React, { useState } from "react";
import TeamMember from "./tabs/TeamMember";
import GeneralInformation from "./tabs/GeneralInformations";
import ProjectActivities from "./tabs/ProjectActivities";
import { useLocation } from "react-router-dom";
import { useManageProjectContext } from "../../../context/ManageProjectContext";
import { useLoading } from "../../../context/LoadingContext";

const TabNames: string[] = [
  "General Information",
  "Team Members",
  "Project Activities",
];

const UpdateProjectPage: React.FC = () => {
  const location = useLocation();
  const { setProjectFormType, projectDetail, getProjectDetails } =
    useManageProjectContext();
  const { isLoading } = useLoading();
  const [activeTab, setActiveTab] = useState<string>("General Information");

  const state = location.state as { id: number } | undefined;
  const projectID = state?.id;

  React.useEffect(() => {
    setProjectFormType("update");
    getProjectDetails(Number(projectID));
  }, [projectID, getProjectDetails, setProjectFormType]);

  // Check if project is closed (end_ts < today)
  const isProjectClosed = (): boolean => {
    if (!projectDetail?.end_ts) return false;
    const endDate = new Date(projectDetail.end_ts);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    return endDate < today;
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <div>
      <div className="mb-4 border-b border-gray-200 dark:border-gray-700">
        <ul
          className="flex flex-wrap -mb-px text-sm font-medium text-center"
          id="default-tab"
          data-tabs-toggle="#default-tab-content"
          role="tablist"
        >
          {TabNames.map((item) => (
            <li key={item} className="me-2" role="presentation">
              <button
                className={`inline-block p-4 border-b-2 rounded-t-lg  ${
                  activeTab === item
                    ? "border-blue-600 text-blue-600"
                    : "dark:border-gray-600"
                }`}
                id={item + `-tab`}
                data-tabs-target={`#` + item}
                type="button"
                role="tab"
                aria-controls={item}
                aria-selected={activeTab === item}
                onClick={() => handleTabClick(item)}
              >
                {item}
              </button>
            </li>
          ))}
        </ul>
      </div>
      <div id="default-tab-content">
        {TabNames.map((item) => (
          <div
            key={item}
            className={`p-4 rounded-lg bg-white dark:bg-gray-800 ${activeTab === item ? "block" : "hidden"}`}
            id={item}
            role="tabpanel"
            aria-labelledby={item + "-tab"}
          >
            {activeTab === "General Information" && <GeneralInformation />}
            {activeTab === "Team Members" && (
              <TeamMember details={projectDetail} />
            )}
            {activeTab === "Project Activities" && (
              <ProjectActivities isProjectClosed={isProjectClosed()} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpdateProjectPage;
